export default function LoadingTyping() {
  return (
    <div className="flex gap-1 self-center text-center align-middle leading-none">
      <span
        className="inline-block h-1 w-1 rounded-full bg-gray-600"
        style={{ animation: "type-animation 1s ease-in-out 0ms infinite" }}
      />
      <span
        className="inline-block h-1 w-1 rounded-full bg-gray-400"
        style={{ animation: "type-animation 1s ease-in-out 500ms infinite" }}
      />
      <span
        className="inline-block h-1 w-1 rounded-full bg-gray-600"
        style={{ animation: "type-animation 1s ease-in-out 0ms infinite" }}
      />
    </div>
  );
}
